module.exports = __webpack_public_path__ + "img/quick-guides-icon.f7b90172.svg";